<template>
  <div ref="rightHolder" id="rightHolder" class="collection-panel-holder">
    <DataBlock edit-name="DATA" type="collections"/>
    <ColorSelector :key="inCreateCollectionMode" />
    <KeywordSelector
        :key="uploadedFileData"
        :type="'tags'"
    />
    <KeywordSelector :type="'permissions'" />
<!--    <CollectionGroupEdit
        :key="uploadedFileData"
        v-if="RMTSearchType === 1"
        display="edit"
    />-->
    <DisplayCollectionItems
        v-if="inCreateCollectionMode"
        :key="createdCollectionItems"
        display="grid"
        class="createLayout"
        :style="handleLayout"
    />
    <NelsonButton v-if="!inCreateCollectionMode" label="ADD TO COLLECTION" @click="handleAddToCollection"/>
    <ItemQueue />
    <ErrorDisplay></ErrorDisplay>
    <RightPanelButtons
        v-if="RMTPermission"
        :save="handleSave"
        :cancel="handleCollectionCancel"
    />
  </div>
</template>

<script>
import HeaderBlock from '@/components/header/HeaderBlock';
import LibrarySearch from '@/components/libraries/LibrarySearch';
import SelectionHeader from '@/components/header/SelectionHeader';
import DataBlock from '@/components/rmt/DataBlock';
import ColorSelector from '@/components/rmt/ColorSelector';
import CollectionGroupEdit from '@/components/libraries/search/collection/CollectionGroupEdit';
import DisplayCollectionItems from '@/components/libraries/search/collection/DisplayCollectionItems';
import KeywordSelector from '@/components/rmt/KeywordSelector';
import {mapStores, storeToRefs} from 'pinia/dist/pinia';
import {useRMTStore} from '@/store/RMTStore';
import RightPanelButtons from '@/components/rmt/RightPanelButtons';
import {useModalStore} from '@/store/ModalStore';
import ErrorDisplay from '@/components/rmt/ErrorDisplay';
import ItemQueue from '@/components/libraries/search/ItemQueue';
import NelsonButton from '@/components/nelson/NelsonButton';

export default {
  name: 'CollectionPanel',
  components: {
    HeaderBlock,
    LibrarySearch,
    SelectionHeader,
    DataBlock,
    ColorSelector,
    CollectionGroupEdit,
    DisplayCollectionItems,
    KeywordSelector,
    RightPanelButtons,
    ErrorDisplay,
    ItemQueue,
    NelsonButton
  },
  setup () {
    const RMTStore = useRMTStore();
    const modalStore = useModalStore();
    const { RMTPermission } = storeToRefs(RMTStore);
    return {
      RMTStore, RMTPermission, modalStore
    };
  },
  computed: {
    ...mapStores(useRMTStore),
    inCreateCollectionMode () {
      return this.RMTStore.inCreateCollectionMode;
    },
    createdCollectionItems () {
      return this.RMTStore.createdCollectionItems;
    },
    inUploadMode () {
      return this.RMTStore.inUploadMode;
    },
    RMTSearchType () {
      return this.RMTStore.getSearchType;
    },
    uploadedFileData () {
      return this.RMTStore.uploadedFileData;
    },
    uploadedFiles () {
      return this.RMTStore.uploadedFiles;
    },
    getCancelMode () {
      return this.RMTStore.getCancelMode;
    },
    getCollectionEditItems () {
      return this.RMTStore.getCollectionEditItems;
    },
    handleLayout () {
      let columns;
      if (this.RMTStore.getShowCollectionSearchDisplayType === 'showCollectionGrid') {
        columns = '1fr 1fr 1fr 1fr';
      } else {
        columns = 'auto';
      }
      return {
        'grid-template-columns': columns,
      };
    }
  },
  watch: {
    getCollectionEditItems (to, from) {
      if (to !== from) {
        this.updateCollectionEditDisplay = !this.updateCollectionEditDisplay;
      }
    },
    getCancelMode (to) {
      this.cancelMode = to;
    },
    RMTSearchType (t, o) {
      this.RMTStore.setPageY(o, window.scrollY);
    },
  },
  mounted () {
    this.cancelMode = 1;
    // todo: getting this working using strings but should use id from server
    localStorage.setItem(
        'recent',
        JSON.stringify([
          'Soybeans',
          'Stonefruit',
          'Sugar Beets',
          'Green',
          'Crops',
          'Permission 1',
        ])
    );
    localStorage.getItem('recent');
  },
  methods: {

    handleCollectionCancel (e) {

      // TODO: add mode in which if nothing has been edited, hitting cancel doesn't require a prompt
      e.stopImmediatePropagation();
      this.modalStore.setModalObj({
        promptLabel: 'Cancel Collection Edit',
        promptDescription: 'Are you sure you want to cancel your edits?',
        showInput: false,
        buttonALabel: 'Cancel',
        buttonAFunc: this.cancelPrompt,
        buttonBLabel: 'CONFIRM',
        buttonBFunc: this.confirmCancelEdit
      });
      this.modalStore.showModal('prompt');

    },

    cancelPrompt () {

      this.modalStore.hideModal();

    },

    confirmCancelEdit (e) {

      e.stopImmediatePropagation();
      this.cancelPrompt();
      this.RMTStore.panelIsHidden = true;

      // todo: below can be cleaned up

      this.RMTStore.uploadedFiles = [];
      this.RMTStore.createdCollectionId = [];
      this.RMTStore.createdCollectionItems = [];
      this.RMTStore.editCollectionItems = [];
      this.RMTStore.editCollectionId = [];
      this.RMTStore.setCancelMode(0);
      this.RMTStore.clearSelectedCollections();
      this.RMTStore.inCreateCollectionMode = false;
      this.RMTStore.isAddResource = false;

    },
    handleSave (e) {

      e.stopImmediatePropagation();
      this.RMTStore.saveStuff();

    },
    checkData () {

      if (
          this.RMTStore.uploadedFileData === undefined ||
          this.RMTStore.uploadedFileData === null
      ) {
        return false;
      }

    },
    setRMTSearchType (num) {

      this.RMTStore.isEdit = false;
      this.RMTStore.uploadedFiles = [];
      this.RMTStore.uploadedFileData = [];
      this.RMTStore.clearSelectedResources();
      this.RMTStore.setRMTSearchType(num);

    },

    handleAddToCollection (e) {

      e.stopPropagation();
      this.RMTStore.inCreateCollectionMode = true;
      this.RMTStore.inMultiSelectionMode = true;

    }

  },
};
</script>

<style scoped>

.collection-panel-holder {
  width: 100%;
  height: 100%;
  padding-left: 10px;
  padding-right: 10px;
  overflow-y: auto;

}

</style>